// Инициализация datetimepicker с русской локалью и активацией при клике по инпуту
// Принимает в качестве параметра jQuery объект, представляющий собой инпут
// Возвращает datetimepicker
var datetimepickerInit = function (options) {
  if (options.$input.attr('readonly')) {
    return {};
  }
  var $datetimepicker = options.$input.closest('.date');
  var defaultFormat = options.withSeconds ? 'DD-MM-YYYY HH:mm:ss' : 'DD-MM-YYYY HH:mm';
  var datetimepicker = $datetimepicker.datetimepicker({
    locale: 'ru',
    format: options.format ? options.format : defaultFormat,
    allowInputToggle: true,
    useCurrent: false, // При клике не вставляет текущую дату
    showClear: options.showClear,
  });

  return datetimepicker;
}

// Инициализация двух datetimepicker с русской локалью и активацией при клике по инпуту, представляющих собой диапазон дат
// Принимает в качестве параметра jQuery объекты, представляющие собой инпуты "С" и "По"
// Возвращает объект в котором datetimepickerFrom будет datetimepicker представляющий начала диапазона,
// а datetimepickerTo будет datetimepicker представляющий конец диапазона
var datetimepickerRangeInit = function (options) {
  if (options.$inputFrom.attr('readonly') || options.$inputTo.attr('readonly')) {
    return {};
  }
  var $datetimepickerFrom = options.$inputFrom.closest('.date');
  var $datetimepickerTo = options.$inputTo.closest('.date');
  var defaultFormat = options.withSeconds ? 'DD-MM-YYYY HH:mm:ss' : 'DD-MM-YYYY HH:mm';
  var datetimepickerFrom = $datetimepickerFrom.datetimepicker({
    locale: 'ru',
    format: options.format ? options.format : defaultFormat,
    allowInputToggle: true,
    useCurrent: false, // При клике не вставляет текущую дату
    showClear: options.showClear,
    widgetPositioning: {
      vertical: 'bottom'
    }
  });
  var datetimepickerTo = $datetimepickerTo.datetimepicker({
    locale: 'ru',
    format: options.format ? options.format : defaultFormat,
    allowInputToggle: true,
    showClear: options.showClear,
    useCurrent: false, //Important! See issue #1075
    widgetPositioning: {
      vertical: 'bottom'
    }
  });
  // Если у инпута "С" есть значение, то ограничиваем datetimepicker "По"
  if (options.$inputFrom.val()) {
    $datetimepickerTo.data("DateTimePicker").minDate(options.$inputFrom.val());
  }
  // Если у инпута "По" есть значение, то ограничиваем datetimepicker "С"
  if (options.$inputTo.val()) {
    $datetimepickerFrom.data("DateTimePicker").maxDate(options.$inputTo.val());
  }
  // Если произошел ввод значения в datetimepicker "С" есть значение, то ограничиваем datetimepicker "По"
  $datetimepickerFrom.on("dp.change", function (e) {
    $datetimepickerTo.data("DateTimePicker").minDate(e.date);
    if (options.$inputFromOnChangeFunc) {
      options.$inputFromOnChangeFunc();
    }
  });
  // Если произошел ввод значения в datetimepicker "По" есть значение, то ограничиваем datetimepicker "С"
  $datetimepickerTo.on("dp.change", function (e) {
    $datetimepickerFrom.data("DateTimePicker").maxDate(e.date);
    if (options.$inputToOnChangeFunc) {
      options.$inputToOnChangeFunc();
    }
  });

  return { datetimepickerFrom: datetimepickerFrom, datetimepickerTo: datetimepickerTo };
}

var dateRangeInit = function (options) {
  if (options.$inputFrom.attr('readonly') || options.$inputTo.attr('readonly')) {
    return {};
  }
  var $datepickerFrom = options.$inputFrom.closest('.date');
  var $datepickerTo = options.$inputTo.closest('.date');
  var defaultFormat = options.withSeconds ? 'DD-MM-YYYY HH:mm:ss' : 'DD-MM-YYYY HH:mm';
  var datepickerFrom = $datepickerFrom.datepicker({
    language: 'ru',
    format: options.format ? options.format : defaultFormat,
    todayHighlight: true,
    toggleActive: true,
    autoclose: true,
    startDate: 0,
    endDate: 0,
    clearBtn: options.showClear
  })
  // Если произошел ввод значения в datepicker "С" есть значение, то ограничиваем datepicker "По"
  .on("changeDate", function (selected) {
    var minDate = selected.date ? selected.date.valueOf() : 0;
    $datepickerTo.datepicker('setStartDate', new Date(minDate));
    if (options.$inputFromOnChangeFunc) {
      options.$inputFromOnChangeFunc();
    }
  })
  .on('clearDate', function (e) {
    var minDate = e.date ? e.date.valueOf() : 0;
    $datepickerTo.datepicker('setStartDate', new Date(minDate));
    if (options.$inputToOnChangeFunc) {
      options.$inputToOnChangeFunc();
    }
  });
  var datepickerTo = $datepickerTo.datepicker({
    language: 'ru',
    format: options.format ? options.format : defaultFormat,
    todayHighlight: true,
    toggleActive: true,
    autoclose: true,
    startDate: 0,
    endDate: 0,
    clearBtn: options.showClear
  })
  // Если произошел ввод значения в datepicker "По" есть значение, то ограничиваем datepicker "С"
  .on("changeDate", function (selected) {
    var maxDate = selected.date ? selected.date.valueOf() : new Date(8640000000000000); // set selected date, or date max
    $datepickerFrom.datepicker('setEndDate', new Date(maxDate));
    if (options.$inputToOnChangeFunc) {
      options.$inputToOnChangeFunc();
    }
  })
  .on('clearDate', function (e) {
    var maxDate = e.date ? e.date.valueOf() : new Date(8640000000000000); // set selected date, or date max
    $datepickerFrom.datepicker('setEndDate', new Date(maxDate));
    if (options.$inputToOnChangeFunc) {
      options.$inputToOnChangeFunc();
    }
  });
  // Если у инпута "С" есть значение, то ограничиваем datetimepicker "По"
  if (options.$inputFrom.val()) {
    $datepickerTo.datepicker('setStartDate', new Date(options.$inputFrom.val()));
  }
  // Если у инпута "По" есть значение, то ограничиваем datetimepicker "С"
  if (options.$inputTo.val()) {
    $datepickerFrom.datepicker('setEndDate', new Date(options.$inputTo.val()));
  }
}

var datepickerInit = function (options) {
    if (options.$input.attr('readonly')) {
        return {};
    }
    var $datepicker = options.$input.closest('.date');
    var defaultFormat = options.withSeconds ? 'DD-MM-YYYY HH:mm:ss' : 'DD-MM-YYYY HH:mm';
    var datepicker = $datepicker.datepicker({
        language: 'ru',
        format: options.format ? options.format : defaultFormat,
        todayHighlight: true,
        toggleActive: true,
        autoclose: true,
        startDate: 0,
        endDate: 0,
        clearBtn: options.showClear
    })
    // Если произошел ввод значения в datepicker "С" есть значение, то ограничиваем datepicker "По"
    .on("changeDate", function (selected) {
        if (options.$inputOnChangeFunc) {
            options.$inputOnChangeFunc();
        }
    })
    .on('clearDate', function (e) {
        if (options.$inputOnChangeFunc) {
            options.$inputOnChangeFunc();
        }
    });
}